import {
  PriceMatchPromiseTerms,
  getStaticProps,
} from 'routes/public/PriceMatchPromiseTerms'

export { getStaticProps }

export default PriceMatchPromiseTerms
